import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { retry, timeout } from 'rxjs/operators';

import { NetworkRepository } from '@app/domain/repositories/network/network.repository.contract';
import { Logger } from '@app/services';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class NetworkRepositoryImpl extends MRepository implements NetworkRepository {
  private logger = new Logger('NetworkProvider');

  constructor() {
    super(`${ENV.API_URL}`);
  }

  getLogger(): Logger {
    return this.logger;
  }

  async hasServerConnection(
    maxRetries: number = 2,
    requestTimeout: number = 2000,
    noRetry: boolean = false
  ): Promise<boolean> {
    const httpObserver: Observable<MSafeAny> = this.get('/health-check');
    const httpPromise: Promise<MSafeAny> = noRetry
      ? firstValueFrom(httpObserver)
      : firstValueFrom(httpObserver.pipe(timeout(requestTimeout), retry(maxRetries)));
    return httpPromise
      .then(() => true)
      .catch(() => {
        this.logger.error('HealthCheck failed - no connection');
        return false;
      });
  }
}
